import { render, staticRenderFns } from "./costoptimizat.vue?vue&type=template&id=0f579404&scoped=true&"
import script from "./costoptimizat.vue?vue&type=script&lang=js&"
export * from "./costoptimizat.vue?vue&type=script&lang=js&"
import style0 from "./costoptimizat.vue?vue&type=style&index=0&id=0f579404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f579404",
  null
  
)

export default component.exports